import { ref } from 'vue';
import { useLocale } from './useLocale';

import { post } from '@/api/httpClient';
import type { CalculateHousingPurchaseTaxesResult } from '@/typings/taxes/CalculateHousingPurchaseTaxesResult';

export function useTaxesApi() {
  const calculateTaxesLoading = ref(false);
  const calculateTaxesError = ref<string | undefined>();
  const { getLocale } = useLocale();

  async function calculateHousingPurchaseTaxes(purchasePrice: number): Promise<CalculateHousingPurchaseTaxesResult | undefined> {
    try {
      calculateTaxesLoading.value = true;
      const lang = getLocale();

      const result = await post<{ purchasePrice: number }, CalculateHousingPurchaseTaxesResult>(
        `/taxes/calculate?locale=${lang}`,
        {
          purchasePrice
        }
      );
      return result;
    } catch (err) {
      calculateTaxesError.value = err instanceof Error ? err.message : 'Unknown error';
      console.error('Erreur lors du calcul des taxes', calculateTaxesError.value);
      return undefined;
    } finally {
      calculateTaxesLoading.value = false;
    }
  }

  return {
    calculateHousingPurchaseTaxes,
    calculateTaxesLoading,
    calculateTaxesError
  };
}